<template>
  <div class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <div class="loginForm">
        <p class="loginTitle">Your password has been updated</p>
        <div class="centerImage">
          <img
            class="sentEmailIcons"
            src="@/assets/verificationEmailIcon.png"
          />
        </div>
        <div class="loginSignupDivider"></div>
        <div class="signupBox">
          <router-link class="joinButtonSmall toSignup" :to="{ name: 'Login' }"
            >Back to log in</router-link
          >
        </div>
      </div>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
